/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TourStatusEnum = 1 | 2 | 3 | 4;

export const TourStatusEnum = {
    NUMBER_1: 1 as TourStatusEnum,
    NUMBER_2: 2 as TourStatusEnum,
    NUMBER_3: 3 as TourStatusEnum,
    NUMBER_4: 4 as TourStatusEnum
};

